export type IconProps = React.SVGProps<SVGSVGElement>;
export const HeartIcon = () => (

<svg width="17" height="15" viewBox="0 0 17 15" fill='rgba(247, 0, 0, 1)'  xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" fill='rgba(247, 0, 0, 1)'  clipRule="evenodd" 
   d={"M8.34335 1.0327C10.4234 -0.504114 13.3149 -0.287967 15.1433 1.54104C16.124 2.52101 16.6749 3.85053 16.6749 5.23687C16.6749 6.62321 16.124 7.95273 15.1433 8.9327L8.93501 15.141C8.77854 15.2988 8.56554 15.3875 8.34335 15.3875C8.12115 15.3875 7.90815 15.2988 7.75168 15.141L1.54335 8.9327C-0.401944 7.00099 -0.523465 3.89429 1.26499 1.81652C3.05345 -0.261241 6.14363 -0.603432 8.34335 1.0327Z"}/>
</svg>
);

export default HeartIcon;